import {
  colors,
  typography as typographyTokens,
} from '@dixa/lib-shared-tokens';

type Colors = Record<string, string>;

export const hexStringToNumber = (hex: string): number =>
  parseInt(hex.slice(1), 16);

export const dixaColorsToNumbers = <T extends Colors>(
  colors: T,
): Record<keyof T, number> =>
  Object.fromEntries(
    Object.entries(colors).map(([key, hex]) => [key, hexStringToNumber(hex)]),
  ) as Record<keyof T, number>;

export const white = 0xffffff;

export const neutral = dixaColorsToNumbers(colors.neutral);
export const blue = dixaColorsToNumbers(colors.blue);
export const red = dixaColorsToNumbers(colors.red);
export const purple = dixaColorsToNumbers(colors.purple);
export const typography = dixaColorsToNumbers(typographyTokens.color);
